<h1 mat-dialog-title>Import tasks</h1>

<div mat-dialog-content>
  <input
    *ngIf="showFileInput"
    #uploadImportTasks
    type="file"
    (change)="onImportFileSelected($event)"
  />

  <div *ngFor="let importUser of importUsers">
    {{ importUser.name }} ({{ importUser.taskCount }} tasks) <br />
    <mat-form-field>
      <mat-label>Matching user</mat-label>
      <mat-select [(value)]="importUser.selected">
        <mat-option
          *ngFor="let spaceUser of spaceUsers"
          [value]="spaceUser._id"
          >{{ spaceUser.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Cancel</button>
  <button
    *ngIf="!showFileInput"
    mat-raised-button
    color="primary"
    (click)="runImportTasks()"
  >
    Update
  </button>
</div>
